export let meta = {

	"home": {
		title: "Storage | Storage Units | Self Storage | Rent-A-Store",
		keywords: "storage, rent-a-store, self-storage, self storage",
		description: "Convenient and secure storage units near you! Our self storage solutions come with Free Move-In transport.",
		// description: "Convenient and secure storage units near you! Our self storage solutions come with Free Move-In transport plus 10 Free storage boxes.",
	},

	"careers": {
		title: "Careers - Rent-A-Store",
		keywords: "rent-a-store careers",
		description: "We employ efficient, clear headed and enthusiastic staff who can help us provide service excellence.",
	},

	"contact": {
		title: "Contact us - Rent-A-Store",
		keywords: "",
		description: "Whether you're looking for more information or want to send us your valued feedback, we'd like to hear from you.",
	},

	"refer": {
		title: "Refer a friend - Rent-A-Store",
		keywords: "",
		description: "",
	},

	"facility-standards": {
		title: "Facility Standards - Rent-A-Store",
		keywords: "",
		description: "A visit to any of our self storage facilities will demonstrate that we maintain consistently high standards.",
	},

	"moving-tips": {
		title: "Moving tips - Rent-A-Store",
		keywords: "",
		description: "Useful moving tips to help you plan, pack, stack and organise the contents of your storage unit.",
	},

	"payment-terms": {
		title: "Payment terms - Rent-A-Store",
		keywords: "",
		description: "You don't need to pay a deposit when moving in. Find answers to common payments questions here.",
	},

	"privacy": {
		title: "Privacy statement - Rent-A-Store",
		keywords: "",
		description: "Rent-A-Store respects your privacy. This Privacy Statement informs you of our privacy practices.",
	},

	"security": {
		title: "Security - Rent-A-Store",
		keywords: "",
		description: "Enjoy peace of mind that we take comprehensive measures to maintain safe and secure storage facilities.",
	},

	"faqs": {
		title: "Frequently asked questions- Rent-A-Store",
		keywords: "",
		description: "We maintain a detailed list of questions and answers with links to additional information, based on questions our customers frequently ask.",
	},

	"free-move-in-transport": {
		title: "Free move-in transport - Rent-A-Store",
		keywords: "",
		description: "Free truck and driver or trailer hire makes moving and storing your belongings more cost effective, convenient, and hassle free.",
	},

	"unit-reserved": {
		title: "Unit reserved - Rent-A-Store",
		keywords: "",
		description: "",
	},

	"vip": {
		title: "Contact us - Rent-A-Store",
		keywords: "",
		description: "Haven't experienced the service excellence you expected from Rent-A-Store? We'd like to fix this!",
		robots: "noindex",
	},

	"blog": {
		title: "Blog - Rent-A-Store",
		keywords: "",
		description: "Learn all things about self storage, storage tips and Rent-A-Stores storage facilties by reading our collection of blog posts.",
	},

	"404": {
		title: "Page not found - Rent-A-Store",
		keywords: "",
		description: "",
	},

	"units-midrand": {
		title: "Storage units in Midrand - Rent-A-Store",
		keywords: "",
		description: "Affordable storage units in Midrand. Rent-A-Store offers secure storage that is designed to meet all your self-storage needs in Midrand.",
		canonical: "https://rentastore.co.za/storage-facility/midrand/storage-units"
	},
	"units-sandton": {
		title: "Storage units in Sandton - Rent-A-Store",
		keywords: "",
		description: "Affordable storage units in Sandton. Rent-A-Store offers secure storage that is designed to meet all your self-storage needs in Sandton.",
		canonical: "https://rentastore.co.za/storage-facility/sandton/storage-units"
	},
	"units-honeydew": {
		title: "Storage units in Honeydew - Rent-A-Store",
		keywords: "",
		description: "Affordable storage units in Honeydew. Rent-A-Store offers secure storage that is designed to meet all your self-storage needs in Honeydew.",
		canonical: "https://rentastore.co.za/storage-facility/honeydew/storage-units"
	},
	"units-pretoria": {
		title: "Storage units in Pretoria - Rent-A-Store",
		keywords: "",
		description: "Affordable storage units in Pretoria. Rent-A-Store offers secure storage that is designed to meet all your self-storage needs in Pretoria.",
		canonical: "https://rentastore.co.za/storage-facility/pretoria/storage-units"
	},
	"units-centurion": {
		title: "Storage units in Centurion - Rent-A-Store",
		keywords: "",
		description: "Affordable storage units in Centurion. Rent-A-Store offers secure storage that is designed to meet all your self-storage needs in Centurion.",
		canonical: "https://rentastore.co.za/storage-facility/centurion/storage-units"
	},
	"furniture-storage": {
		title: "Furniture Storage - Rent-A-Store ",
		keywords: "",
		description: "Convenient furniture storage! Store furniture at a Rent-A-Store near you and get 50% off the first 3 months. Book your storage online now.",
		canonical: "https://rentastore.co.za/furniture-storage"
	},
	"car-storage-units-and-parking-bays": {
		title: "Car Storage Units and Parking Bays - Rent-A-Store ",
		keywords: "",
		description: "Convenient car storage units and parking bays! Store your vehicle at a Rent-A-Store near you. Book your storage online now.",
		canonical: "https://rentastore.co.za/car-storage-units-and-parking-bays"
	},
}
